export default {
  text: {
    en: 'Did you mean <span class="brandColor">...@<b>{domainName}</b></span>?',
  },
  button: {
    en: 'yes',
  },
}
